import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { HEADER_NAV_MORE_ITEM } from '../../brands/default/content/components/find';

const HeaderNavigationMoreItem = ({ navigation }) => {
  const [isOpen, setIsOpen] = useState(false);
  const moreItems = navigation.slice(10);

  return (
    <>
      <li
        className="navigation-item"
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        {moreItems?.length > 0 && (
          <button className="navigation-item__button" type="button">
            {'more'}
            <span className="navigation-item__plus"> +</span>
          </button>
        )}
      </li>
      {isOpen && (
        <div
          className="navigation-more__list"
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
        >
          <h3 className="navigation-more__header">
            {HEADER_NAV_MORE_ITEM.moreCategories}
          </h3>
          <li className="more__list">
            {moreItems.map((item) => (
              <li className="more-item" key={item.id}>
                <Link href={item.url}>
                  <a target={item.externalLink ? '_blank' : '_self'}>
                    {item.linkText}
                  </a>
                </Link>
              </li>
            ))}
          </li>
        </div>
      )}
      <style jsx>{`
        .navigation-item {
          list-style: none;
          display: flex;
          align-items: left;
          margin-right: 10px;
        }
        .navigation-item:hover .navigation-item__button {
          color: #eb008c;
        }
        .navigation-item__button {
          align-items: center;
          background-color: #fff;
          border-bottom: 2px solid transparent;
          border-radius: 4px;
          border: none;
          color: #666;
          display: flex;
          font-size: 13px;
          font-weight: bold;
          height: calc(100% - 10px);
          justify-content: center;
          margin: 5px;
          padding: 2px 10px 0 10px;
          text-decoration: none;
          text-transform: uppercase;
          white-space: nowrap;
        }
        .navigation-item__plus {
          position: relative;
          top: -1px;
          white-space: pre;
        }
        .navigation-more__list {
          animation-fill-mode: backwards;
          animation: popover-in 0.2s;
          background-color: #f9f9f9;
          background-color: white;
          border-radius: 4px;
          border: 1px solid #aaaaaa;
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
          box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
          display: block;
          left: 80%;
          list-style: none;
          min-width: 160px;
          padding: 10px;
          position: absolute;
          top: 35px;
          width: 300px;
          z-index: 1;
        }
        .navigation-more__header {
          color: #999;
          font-size: 13px;
          text-transform: uppercase;
          font-weight: bold;
          margin: 10px 10px 0 10px;
          text-align: left;
        }
        .more__list {
          padding: 10px;
          text-align: left;
          text-decoration: none;
        }
        .more-item {
          font-size: 13px;
          text-transform: uppercase;
          height: 26px;
        }
        .more-item a {
          align-items: center;
          color: #111111;
          color: #666;
          cursor: pointer;
          display: flex;
          height: 100%;
          text-decoration: none;
          width: 100%;
        }
        .more-item a:hover {
          color: #eb008c;
        }
      `}</style>
    </>
  );
};
HeaderNavigationMoreItem.propTypes = {
  navigation: PropTypes.array,
};
export default HeaderNavigationMoreItem;
